import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  goFecha_AAAAMMDD(fecha: string | Date): string {
    const day = new Date(fecha).getDate();
    const month = new Date(fecha).getMonth() + 1;
    const year = new Date(fecha).getFullYear();
    const fechaFinal = `${year}-${month}-${day}`;
    return fechaFinal;
  }

  goFecha_DDMMAAAAHHMM(fecha: Date): string {

    let fechaString: string = '';

    if (fecha !== null) {
      const day = new Date(fecha).getDate();
      const month = new Date(fecha).getMonth() + 1;
      const year = new Date(fecha).getFullYear();
      const hour = new Date(fecha).getHours();
      const minute = new Date(fecha).getMinutes();
      fechaString = `${day}/${month}/${year} ${hour}:${minute}`;
    } 

    if (fechaString === '1/1/1 0:0') {
      fechaString = null;
    }

    return fechaString;
  }

  goFecha(fecha: Date, hora: string): Date {
    let fechaString: Date;

    const day = new Date(fecha).getDate();
    const month = new Date(fecha).getMonth() + 1;
    const year = new Date(fecha).getFullYear();
    fechaString = new Date(`${year}-${month}-${day} ${hora}`);

    return fechaString;
  }

  goAnioActual(): number {

    const year = new Date(new Date()).getFullYear();

    return year;
  }

  goFechaAdd(fecha: Date, addday: number,addmonth: number,addyear: number): Date {
    let fechaString: Date;
    const day = new Date(fecha).getDate() + addday;
    const month = new Date(fecha).getMonth() + 1 + addmonth;
    const year = new Date(fecha).getFullYear() + addyear;
    const hour = new Date(fecha).getHours();
    const minute = new Date(fecha).getMinutes();
    fechaString = new Date(`${year}-${month}-${day} ${hour}:${minute}:00`);

    return fechaString;
  }

  goFindRegistroPorCode(data: SelectItem[], find: any): SelectItem{
    
    let item: SelectItem = data.find(xFind => xFind.value === find);

    item = item === undefined ? null : item;

    return item;
  }

  goValidarEmail(email)
  {
    var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email) ? true : false;
  }

  goConvertirMayuscula(data: string): string {

    data = data === null ? '': data;
    data = data === undefined ? '' : data;

    let mayus = data.toUpperCase();

    return mayus;

  }

  formatStringToDate(fecha: string): Date {
    const date = new Date();
    let fechaArr = fecha.split('T')[0].split('-');

    date.setDate(Number(fechaArr[2]));
    date.setMonth(Number(fechaArr[1]) - 1);
    date.setFullYear(Number(fechaArr[0]));

    return date
  }
  
}
